//Lucce API server
let check_url = 'https://api.luccerings.com'
// check_url = 'http://127.0.0.1:8022'

check_cart()

if(window.location.pathname == '/cart'){
    //check cart every 5 mins if on cart page
    setInterval(check_cart,300000)
}

function check_cart(){
    $.ajax({
        type:'GET',
        url:'\\cart.js',
        success: function(data){
                data = JSON.parse(data)
                let products = []
                let items = data['items']
                items.forEach(item=>{
                    if (item['product_type'] == 'api-diamond'){
                        products.push({
                            id:item['id'],
                            title:item['title'],
                        
                        })
                    }
                })
                
                let post_data = {
                    data: products
                }
    
                if(products.length > 0){
                    fetch(check_url +'/check_cart',
                      {method: 'POST',body: JSON.stringify(post_data)}
                    )
                    .then(resp=>resp.json())
                    .then(json=>{
                        let results = json['check_results']
                        results.forEach(result=>{
                            removeFromCart(result)
                        })
                    })
                }
                
        }     
       });

}




function removeFromCart(id){
    
    $.ajax({
        type:'POST',
        url:'\\cart\\change.js',
        data:{
            id:id,
            quantity:0,
        },
        success: function(data){
                window.alert('The diamond in your cart is no longer available')
                location.reload()
            }
        })
}


async function get_cart_data(){
    return $.ajax({
        type:'GET',
        url:'\\cart.js',
    })

}

function check_cart_checkout(data){
    data = JSON.parse(data)
                let r_settings = []
                let diamonds = []
                let items = data['items']
                items.forEach(item=>{
                    if (item['product_type'] == 'lab diamond'){
                        r_settings.append(item['title'])
                    }

                    if (item['product_type'] == 'api-diamond'){
                        diamonds.append(item['title'])
                    }
                })

                console.log(r_settings)
                console.log(diamonds)
                
}
